import { browserHistory } from 'react-router';
import axios from 'axios';

const baseEndpoint = 'v1/socialnetworks';

const NetworkService = {

  deleteNetwork( id ) {
    return axios
      .delete( `${baseEndpoint}/${id}` )
  },

  sendNetworkAction( network, action ) {
    return axios
      .get( `${baseEndpoint}/${network}/takeactions/${action}` )
  },

  getNetworks( params ) {
    return axios
      .get( baseEndpoint, { params } )
  },

  getNetwork( id ) {
    return axios
      .get( `${baseEndpoint}/${id}` )
  },

  getAccounts() {
    return axios
      .get( `v1/socialnetwork/filters` )
  },

  verifyNetwork( id ) {
    return axios
      .put( `${baseEndpoint}/${id}/active` )
  },

  saveNetwork( data ) {
    if (data.type === 'twitter') {
      delete data.type;
      
      data['twPage']='NA';
      data['accesToken'] = 'NA';
      data['refreshToken']='NA';
      return axios
      .post( `${baseEndpoint}/twitter`, data ) 
    }
    return axios
      .post( baseEndpoint, data )
  },

  updateNetwork(id, data) {
    if (data.type === 'twitter') {
      delete data.type;
      return axios
      .put( `${baseEndpoint}/${id}/twitter`, data ) 
    }
    return axios
      .put( `${baseEndpoint}/${id}`, data )
  },

  syncContacts( idSocialNetwork ) {
    return axios
      .get( `${baseEndpoint}/${idSocialNetwork}/contacts/sync` )
  },

  searchEmailContacts( id ) {
    return axios
      .get( `v1/email-contacts/${id}/own` )
  },

  searchEmailGlobalContacts( id, params ) {
    return axios
      .get( `v1/email-contacts/${id}/global-list`,  { params } )
  },
};

export default NetworkService;



// WEBPACK FOOTER //
// ./services/NetworkService.js